/**
 * DG Custom - Member Pricing Variant Handler
 * Updates member pricing input when variant changes
 * FIXED: Now handles cases where variants don't have member pricing
 */

// Mirrors the entitlement test in snippets/price.liquid and DG-member-context.liquid.
// Fails closed: no context means no member layout.
function isEntitled() {
  return !!(window.dcMember
    && typeof window.dcMember.isEntitled === 'function'
    && window.dcMember.isEntitled() === true);
}

function initializeMemberPricing(container) {
  const variantPicker = container.querySelector('variant-picker');
  const variantMemberPricingDataElement = container.querySelector('[data-club-member-pricing-variants]');
  const memberPriceDisplayElement = container.querySelector('[data-dg-member-price-display]');
  const memberPriceFormInput = container.querySelector('input[name="properties[_club_member_price]"]');

  if (!variantPicker || !variantMemberPricingDataElement) {
    return;
  }

  const variantMemberPricingData = JSON.parse(variantMemberPricingDataElement.textContent);

  variantPicker.addEventListener('on:variant:change', (event) => {
    // `variant` is undefined when the chosen options match no variant. The picker no longer
    // silently snaps to a different variant in that case, so this fires with no variant and
    // must not be dereferenced.
    const selectedVariant = event.detail.variant;
    const selectedVariantMemberPricing = selectedVariant
      && variantMemberPricingData.variants.find(
        (variant) => variant.id === selectedVariant.id
      );
    
    const memberRow = memberPriceDisplayElement
      && memberPriceDisplayElement.closest('.DG-price__member');
    // `.DG-has-member-price` drives the whole member layout in DG-main.css — including hiding the
    // selling price on sale items, because the member price replaces it. It therefore has to be
    // toggled in step with the row, or a variant without a member price would render a struck
    // compare-at and NO price at all.
    const priceBlocks = container.querySelectorAll('.price');

    const hasMemberPrice = selectedVariantMemberPricing
      && selectedVariantMemberPricing.club_member_price
      && selectedVariantMemberPricing.club_member_price.value !== null;

    if (!hasMemberPrice) {
      // This variant has no member price. Returning early here used to leave the PREVIOUS
      // variant's member price on screen — showing a price the customer cannot get for the
      // variant they just selected. Clear it and fall back to normal pricing.
      if (memberRow) memberRow.hidden = true;
      if (memberPriceDisplayElement) memberPriceDisplayElement.textContent = '';
      if (memberPriceFormInput) memberPriceFormInput.value = '';
      priceBlocks.forEach((el) => el.classList.remove('DG-has-member-price'));
      return;
    }

    if (memberRow) memberRow.hidden = false;
    // snippets/price.liquid only emits `.DG-has-member-price` for an entitled customer, so the
    // class must be entitlement-gated here too. Adding it for a non-member hid their selling
    // price via the rule above and left a struck compare-at with no price at all.
    priceBlocks.forEach((el) => el.classList.toggle('DG-has-member-price', isEntitled()));

    // Update the display element
    if (memberPriceDisplayElement) {
      memberPriceDisplayElement.textContent = selectedVariantMemberPricing.club_member_price.asMoney;
    }

    // Update the member price form input
    if (memberPriceFormInput) {
      memberPriceFormInput.value = selectedVariantMemberPricing.club_member_price.value;
    }
  });
}

function handleDocumentClick(event) {
  if (event.target.matches('.js-quick-add')) {
    const quickAddDrawer = document.querySelector('quick-add-drawer');
    if (quickAddDrawer) {
      setTimeout(() => {
        const isOpen = quickAddDrawer.hasAttribute('open');
        if (isOpen) {
          initializeMemberPricing(quickAddDrawer);
        }
      }, 200);
    }
  }
}

function init() {
  document.addEventListener('click', handleDocumentClick.bind(this));
  const productMain = document.querySelector('.product-main');
  if (productMain) {
    initializeMemberPricing(productMain);
  }
}

init();
